"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableBadge = exports.TableBadgeTypes = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var TableBadgeTypes;
(function (TableBadgeTypes) {
    TableBadgeTypes["AMBER"] = "amber";
    TableBadgeTypes["GREEN"] = "green";
    TableBadgeTypes["RED"] = "red";
    TableBadgeTypes["PURPLE"] = "purple";
    TableBadgeTypes["BLACK"] = "black";
    TableBadgeTypes["BLUE"] = "blue";
})(TableBadgeTypes = exports.TableBadgeTypes || (exports.TableBadgeTypes = {}));
var TableBadge = function (props) {
    var type = props.type, badgeText = props.badgeText;
    var cls = (0, BootstrapHelper_1.B)().bl("table-badge")
        .pmod(props.size || "sm")
        .pmod(type || "").bem;
    return (0, jsx_runtime_1.jsx)("span", __assign({ className: "".concat(cls, " ").concat(props.className ? props.className : "") }, { children: badgeText }));
};
exports.TableBadge = TableBadge;
